import { Input, Select } from 'antd';
import styled from 'styled-components';

export const VideoContainer = styled.div`
	width: 100%;
	height: 25rem;
	overflow: hidden;
	border-radius: 15px;
	background-color: black;

	video {
		object-fit: contain;
	}

	@media (min-width: 1600px) {
		height: 16.25rem;
	}
`;

export const CustomTextArea = styled(Input.TextArea)`
	textarea {
		resize: none;
		border-radius: 6px;
		border: 2px solid #e9e9e9;
	}
`;

export const CustomSelect = styled(Select)`
	.ant-select-selector {
		display: flex;
		font-size: 0.9rem;
		align-items: center;
		border: 2px solid #d9d9d9;
		height: 2.5rem !important;
		border-radius: 6px !important;

		span {
			display: flex;
			align-items: center;
		}

		&:hover {
			cursor: pointer;
		}
	}
`;
